import { createBrowserRouter } from "react-router-dom";
import { useMemo, useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import Layout from "@/components/layout";
import NotFound from "@/components/NotFound";
import Register from "@/pages/Register";
import Home from "@/pages/home";
import SecondPage from "@/pages/secondPage";

// about
import WhoWeAre from "@/pages/about/who-we-are";
import MemerberListing from "@/pages/about/member-listing";
import ContactUs from "@/pages/about/contact-us";
import AboutOpenGA from "@/pages/about/openga";

// discover
import OpenData from "@/pages/discover/open";
import OpenDetail from "@/pages/discover/openDetail";
import DetailData from "@/pages/discover/detail";
import Share from "@/pages/discover/share";
import MyShare from "@/pages/discover/my-share";
import Resource from "@/pages/oge/resource";
import ApplicationCenter from "@/pages/oge/applicationCenter";
import CourceHub from "@/pages/discover/course/course-hub";
import MyCourse from "@/pages/discover/course/my-course";
import CourseAddOrEdit from "@/pages/discover/course/courseAddOrEdit";
import CourseDetail from "@/pages/discover/course/course-detail";
import SkillHub from "@/pages/skillhub";
import SkillDetail from "@/pages/skillhub/detail";
import SkillUpload from "@/pages/skillhub/upload";
import OpenGA from "@/pages/openGA";

// infrastructure
import DevelopCenter from "@/pages/oge/developCenter";

// community
import Events from "@/pages/community/events";
import HowToShare from "@/pages/community/how-to-share";
import Communications from "@/pages/community/communications";
import MatchCenter from "@/pages/community/match-center";

// blog-news
// import Blog from "@/pages/blog-news/blog";
import News from "@/pages/blog-news/news";
import Detail from "@/pages/blog-news/detail";

// management-center
import DataStatistics from "@/pages/management-center/dataStatistics";
import NewsManagement from "@/pages/management-center/news";
import EventsManagement from "@/pages/management-center/events";
import UserManagement from "@/pages/management-center/user";
import MaterialManagement from "@/pages/management-center/material";
import AddNews from "@/pages/management-center/news/components/addNews";
import AddEvents from "@/pages/management-center/events/components/addEvents";
import Personal from "@/pages/management-center/personal";
import DataAuditing from "@/pages/management-center/data-auditing";
import SkillHubAuditing from "@/pages/management-center/skillhub-auditing";
import CommentAuditing from "@/pages/management-center/comment";
import TagsManage from "@/pages/management-center/tags";

import User from "@/pages/user";
// import { useSelector } from "react-redux";

// file
import File from "@/pages/file";

// 空白页
import BlankPage from "@/pages/blankPage";
// ... 其他原有 import ...

const AppRouter = () => {
  const [roleId, setRoleId] = useState(localStorage.getItem("roleId"));
  // 监听 localStorage 变化
  useEffect(() => {
    const handleStorageChange = () => {
      setRoleId(localStorage.getItem("roleId"));
    };

    // 自定义 storage 事件处理
    window.addEventListener("setRoleId", handleStorageChange);
    return () => window.removeEventListener("setRoleId", handleStorageChange);
  }, []);
  const baseRoutes = [
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: "detail",
          element: <Detail />,
        },
        {
          path: "/register",
          element: <Register />,
        },
        {
          path: "/user",
          element: <User />,
        },
        {
          path: "/skillhub",
          element: <SkillHub />,
        },
        {
          path: "/openGA",
          element: <OpenGA />,
        },
        {
          path: "/skillhub/detail",
          element: <SkillDetail />,
        },
        {
          path: "/skillhub/upload",
          element: <SkillUpload />,
        },
        {
          path: "*",
          element: <NotFound />,
        },
        {
          path: "about/",
          children: [
            {
              path: "openga",
              element: <AboutOpenGA />,
            },
            {
              path: "who-we-are",
              element: <WhoWeAre />,
            },
            {
              path: "member-listing",
              element: <MemerberListing />,
            },
            {
              path: "contact-us",
              element: <ContactUs />,
            },
          ],
        },
        {
          path: "discover/",
          children: [
            {
              path: "open-detail",
              element: <OpenDetail />,
            },
            {
              path: "open-datasets",
              element: <OpenData />,
            },
            {
              path: "share",
              element: <Share />,
            },
            {
              path: "my-share",
              element: <MyShare />,
            },
            {
              path: "detail",
              element: <DetailData />,
            },
            {
              path: "my-course",
              element: <MyCourse />,
            },
            {
              path: "course-add-edit",
              element: <CourseAddOrEdit />,
            },
            {
              path: "course-detail",
              element: <CourseDetail />,
            },
          ],
        },
        {
          path: "infrastructure/",
          children: [
            {
              path: "developCenter",
              element: <DevelopCenter />,
            },
            {
              path: "resourceCenter",
              element: <Resource />,
            },
            {
              path: "applicationCenter",
              element: <ApplicationCenter />,
            },
            {
              path: "course-hub",
              element: <CourceHub />,
            },
            {
              path: "skillhub",
              element: <SkillHub />,
            },
            {
              path: "openGA",
              element: <OpenGA />,
            },
          ],
        },
        {
          path: "community/",
          children: [
            {
              path: "how-to-share",
              element: <HowToShare />,
            },
            {
              path: "communications",
              element: <Communications />,
            },
            {
              path: "match-center",
              element: <MatchCenter />,
            },
            {
              path: "news",
              element: <News />,
            },
            {
              path: "events",
              element: <Events />,
            },
          ],
        },
        // {
        //   path: "blog-news/",
        //   children: [
        //     {
        //       path: "blog",
        //       element: <Blog />,
        //     },
        //     {
        //       path: "news",
        //       element: <News />,
        //     },
        //     {
        //       path: "events",
        //       element: <Events />,
        //     },
        //   ],
        // },
      ],
    },
    {
      path: "/file",
      element: <File />,
    },
    {
      path: "CityGML2.0_ChineseVersion",
      element: <SecondPage />,
    },
    {
      path: "blank-page",
      element: <BlankPage />,
    },
  ];
  // 动态路由生成函数
  const generateRouter = useMemo(() => {
    const dynamicRoutes = [...baseRoutes];
    if (roleId === "1") {
      dynamicRoutes[0].children.push({
        path: "administration/",
        children: [
          {
            path: "data-statistics",
            element: <DataStatistics />,
          },
          {
            path: "tags-manage",
            element: <TagsManage />,
          },
          // {
          //   path: "news",
          //   element: <NewsManagement />,
          // },
          {
            path: "news",
            element: <NewsManagement />,
          },
          {
            path: "events",
            element: <EventsManagement />,
          },
          {
            path: "user",
            element: <UserManagement />,
          },
          {
            path: "material",
            element: <MaterialManagement />,
          },
          // {
          //   path: "Personal",
          //   element: <Personal />,
          // },
          {
            path: "news/add",
            element: <AddNews />,
          },
          {
            path: "events/add",
            element: <AddEvents />,
          },
          {
            path: "data-auditing",
            element: <DataAuditing />,
          },
          {
            path: "skillhub-auditing",
            element: <SkillHubAuditing />,
          },
          {
            path: "comment-auditing",
            element: <CommentAuditing />,
          },
        ],
      });
    }
    if (roleId) {
      dynamicRoutes[0].children.push({
        // path: "member-listing",
        // element: <MemerberListing />,
        path: "/personal",
        element: <Personal />,
      });
    }
    return createBrowserRouter(dynamicRoutes, {
      basename: process.env.PUBLIC_URL,
    });
  }, [roleId]); // 依赖 roleId
  return <RouterProvider router={generateRouter} key={roleId} />;
};

// 修改登录/退出时更新 localStorage 的方式
// 在修改 roleId 的地方调用：
// const updateRole = (newRoleId) => {
//   localStorage.setItem("roleId", newRoleId);
//   window.dispatchEvent(new Event("setRoleId")); // 触发自定义事件
// };

export default AppRouter;
